module.exports = __webpack_public_path__ + "img/about/80243-039.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-039.png
// module id = 37
// module chunks = 0